import {Component, Input} from '@angular/core';

@Component({
    selector: 'rr-fedex-tracking',
    templateUrl: './fedex-tracking.component.html',
    styleUrls: ['./fedex-tracking.component.css']
})
export class FedexTrackingComponent {

    @Input('tracking_number') trackingNumber;

    constructor() {
    }
}
